import { CAN_MANAGE_MEMBERS } from "../../common/helpers/workspacePermissions";
import { useActiveWorkspaceRole } from "./useActiveWorkspaceRole";

export function useCanAddMember() {
    const role = useActiveWorkspaceRole();

    return Boolean(role && CAN_MANAGE_MEMBERS.includes(role));
}
